import { StellarTrustLine } from "../../core/types/stellar";
import { TrustLineAsset } from "../../core/types/tokens";
import {
  isValidHorizonAsset,
  isValidIssuedAsset,
} from "../internal/stellarService";

export class StellarApiClient {
  private apiUrl: string;

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  async getBaseReserve() {
    const response = await fetch(`${this.apiUrl}/ledgers?order=desc&limit=1`);

    if (!response.ok) {
      throw new Error(`Failed to fetch ledgers: ${response.status}`);
    }

    const ledgers = await response.json();

    const latestLedger = ledgers?._embedded.records?.[0];

    if (latestLedger?.base_reserve_in_stroops == null) {
      throw new Error("Invalid ledger data");
    }

    const baseReserveBn = BigInt(latestLedger.base_reserve_in_stroops);

    return baseReserveBn;
  }

  async getTrustLines(userAddress: string): Promise<StellarTrustLine[]> {
    const response = await fetch(`${this.apiUrl}/accounts/${userAddress}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch account data: ${response.statusText}`);
    }

    const data = await response.json();

    if (!Array.isArray(data?.balances)) {
      throw new Error("Invalid response from Horizon API");
    }

    const assets = data.balances.filter(isValidHorizonAsset);

    return assets.filter(isValidIssuedAsset);
  }

  async getTrustLine(
    address: string,
    asset: TrustLineAsset
  ): Promise<StellarTrustLine | null> {
    const trustLines = await this.getTrustLines(address);

    const trustLine = trustLines.find(
      (line) =>
        line.asset_code === asset.code && line.asset_issuer === asset.issuer
    );

    return trustLine ?? null;
  }
}
